import { Button, TextField } from "@mui/material";
import { Col, Row } from "react-bootstrap";
import airlineFieldData from "./airlineFieldData";
import { useState } from "react";
import { useSnackbar } from "notistack5";
import { updateAirlineFileApi } from "src/Api/Services/AirlineUploadExcelApi";

const UpdateAirlineUpload = ({ editData, fetchData }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [fieldData, setFieldData] = useState(editData || {});
  const [loading, setLoading] = useState(false);
  const handleSubmit = async (e) => {
    if (loading) return;
    setLoading(true);
    e.preventDefault();
    try {
      const { data } = await updateAirlineFileApi(fieldData);
      enqueueSnackbar(data?.message || "Something went wrong", {
        variant: data?.status ? "success" : "error",
      });
      data?.status && fetchData();
    } catch (error) {}
    setLoading(false);
  };
  return (
    <>
      <form onSubmit={handleSubmit}>
        <Row>
          {airlineFieldData().mainFields.map((item, index) => (
            <Col md={12} xs={12} xl={3} key={index} className="mb-3">
              <TextField
                type={item.type}
                placeholder={item.placeholder}
                size="normal"
                label={item.label}
                name={item.name}
                fullWidth
                value={fieldData[item.name]}
                onChange={(e) => {
                  setFieldData({
                    ...fieldData,
                    [e.target.name]: e.target.value,
                  });
                }}
              />
            </Col>
          ))}
        </Row>
        {fieldData.outbound?.length > 0 && (
          <h3 className=" text-sm font-bold">Out Bound</h3>
        )}
        {fieldData.outbound?.length > 0 && (
          <Row>
            {fieldData.outbound.map((ele, i) => (
              <>
                <p className=" text-sm">Segment {i + 1}</p>
                {airlineFieldData().outBoundFields.map((item, index) => (
                  <Col md={12} xs={12} xl={3} key={index} className="mb-3">
                    <TextField
                      type={item.type}
                      placeholder={item.placeholder}
                      size="normal"
                      label={item.label}
                      name={item.name}
                      fullWidth
                      value={fieldData.outbound[i][item.name]}
                      onChange={(e) =>
                        setFieldData({
                          ...fieldData,
                          outbound: [
                            {
                              ...fieldData.outbound[i],
                              [e.target.name]: e.target.value,
                            },
                          ],
                        })
                      }
                    />
                  </Col>
                ))}
              </>
            ))}
          </Row>
        )}
        {fieldData.inbound?.length > 0 && (
          <h3 className=" text-sm font-bold">In Bound</h3>
        )}
        {fieldData.inbound?.length > 0 && (
          <Row>
            {fieldData.inbound.map((ele, i) => (
              <>
                <p className=" text-sm">Segment {i + 1}</p>
                {airlineFieldData().inBoundFields.map((item, index) => (
                  <Col md={12} xs={12} xl={3} key={index} className="mb-3">
                    <TextField
                      type={item.type}
                      placeholder={item.placeholder}
                      size="normal"
                      label={item.label}
                      name={item.name}
                      fullWidth
                      value={fieldData.inbound[i][item.name]}
                      onChange={(e) => {
                        setFieldData({
                          ...fieldData,
                          inbound: [
                            {
                              ...fieldData.inbound[i],
                              [e.target.name]: e.target.value,
                            },
                          ],
                        });
                      }}
                    />
                  </Col>
                ))}
              </>
            ))}
          </Row>
        )}
        <div className="text-center mt-4">
          <Button
            variant="contained"
            disabled={loading ? true : false}
            type="submit"
          >
            {loading ? "Updating..." : "Update"}
          </Button>
        </div>
      </form>
    </>
  );
};

export default UpdateAirlineUpload;
